// Local Constants
import { RESET_STATE } from '../auth/constants';
import { RE_ENTRY_WARNING_SET, RE_ENTRY_WARNING_RESET } from './constants';

// Local Types
import { ResetStateAction } from '../auth/types';
import { ReEntryWarningState, ReEntryWarningActions } from './types';

const initialState: ReEntryWarningState = false;

export default function ReEntryWarningReducer(
    state: ReEntryWarningState = initialState,
    action: ReEntryWarningActions | ResetStateAction
): ReEntryWarningState {
    switch (action.type) {
        case RE_ENTRY_WARNING_SET:
            return action.payload;
        case RE_ENTRY_WARNING_RESET:
        case RESET_STATE:
            return initialState;
        default:
            return state;
    }
}
